<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1ADrF3u/tc-custom/9781250145666.jpg?1737747073364" alt="This image is the cover for the book Suitors and Sabotage"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Suitors and Sabotage
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Two young people must hide their true feelings for each other while figuring out who means them harm in this cheeky Regency romance </b><b>from the author of <i>Love, Lies and Spies</i> and <i>Duels &amp; Deception</i>. </b><br/><br/>Shy aspiring artist Imogene Chively has just had a successful Season in London, complete with a suitor of her father's approval. Imogene is ambivalent about the young gentleman until he comes to visit her at the Chively estate with his younger brother in tow. When her interest is piqued, however, it is for the wrong brother. <br/><br/>Charming Ben Steeple has a secret: despite being an architectural apprentice, he has no drawing aptitude. When Imogene offers to teach him, Ben is soon smitten by the young lady he considers his brother's intended. <br/><br/>But hiding their true feelings becomes the least of their problems when, after a series of "accidents," it becomes apparent that someone means Ben harm. And as their affection for each other grows—despite their efforts to remain just friends—so does the danger. . .<br/><br/>In <i>Suitors and Sabotage</i>, author Cindy Anstey delivers another witty young adult historical fiction novel that is the perfect mix of sweetly romantic and action-packed. <br/><br/><b>Praise for <i>Suitors and Sabotage:</i><br/><br/>A Junior Library Guild Selection<br/></b><br/>"Anstey’s tale embraces a self-reliant main character, a loyal friend, innocent romance, witty conversation, and English country settings, each more splendid than the last. <b>This is a delightful salute to Jane Austen and will be a treat for her fans.</b>" —<i>VOYA</i><br/><br/>"Mystery and romance are delightfully intertwined . . . Taking inspiration from Jane Austen novels, Anstey's latest is a <b>lighthearted and romantic</b> read." —<i>Booklist</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cindy Anstey
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Feiwel and Friends
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3b72a7d6